import React from 'react';
import { EditPortionState } from './editPortionState/EditPortionState';
import { Modal } from 'antd';
import { Forms } from './components/Forms';
import { ModalWindows } from './components/ModalWindows';
import breadcrumbs from 'assets/img/breadcrumbs.svg';
import style from './index.module.scss';

interface IProps {
	onCloseModal: () => void;
	onFailureEvent?: () => void;
	onShowError: () => void;
}

export const EditPortionModal: React.FC<IProps> = ({ onCloseModal, onFailureEvent, onShowError }) => {
	return (
		<EditPortionState>
			<Modal
				width="60%"
				bodyStyle={{ padding: '34px 40px 20px 40px' }}
				className={style.container}
				onCancel={onFailureEvent}
				footer={null}
				visible={true}
				centered={false}
				destroyOnClose={true}
				closeIcon={
					<svg className={style.closeIcon}>
						<use xlinkHref={`${breadcrumbs}#crossMark`} />
					</svg>
				}
				data-test="EditPortionModal">
				<Forms onFailureEvent={onFailureEvent} onCloseModal={onCloseModal} onShowError={onShowError} />
				<ModalWindows onCloseModal={onCloseModal} />
			</Modal>
		</EditPortionState>
	);
};
